<!--隐私协议-->
<template>
    <div class="reload-view">

        <div class="main">
            <div class="main-cat">收款途径 <span style="color: red">*</span></div>
            <div class="main-cat-option">
                <van-cell-group inset class="main-input">
                    <van-field
                        class="main-input"
                        v-model="catText"
                        right-icon="arrow-down"
                        readonly
                        @click="catShow = true"
                    />
                </van-cell-group>
            </div>
            <div class="main-cat">支付宝账号 <span style="color: red">*</span></div>
            <div class="main-cat-option">
                <van-cell-group inset class="main-input">
                    <van-field
                        class="main-input"
                        v-model="account"
                    />
                </van-cell-group>
            </div>
            <div class="main-cat">姓名 <span style="color: red">*</span></div>
            <div class="main-cat-option">
                <van-cell-group inset class="main-input">
                    <van-field
                        class="main-input"
                        v-model="name"
                    />
                </van-cell-group>
            </div>
            <div class="main-icon-tips">
                <van-icon name="warning-o" color="#FE405F"/> 收款账号每年限更改一次
            </div>
            <div class="btn-container" @click="setAccount">
                保 存
            </div>
        </div>
        <ReferralFooter index="3"/>
    </div>

    <van-popup v-model:show="catShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="catValue"
            :columns="catData"
            @cancel="catShow = false"
            @confirm="catConfirm"
        />
    </van-popup>
</template>

<script>
import ReferralFooter  from "@/components/referralFooter.vue";
import ayzAjax from "@/plugins/axios";
import {showFailToast, showSuccessToast} from "vant";

export default {
    name: "ReloadView",
    components: {
        ReferralFooter
    },
    data: function () {
        return {
            catData:[{value:"1",text:"支付宝"}],
            catText:"支付宝",
            catValue:[1],
            catShow:false,
            cat:null,
            account:'15255718985',
            name:'张三',
            jwtInfo:null,
            userInfo:null,
        }
    },
    created() {
        this.jwtInfo = JSON.parse(localStorage.getItem('jwtInfo'));
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (this.jwtInfo === null || this.userInfo === null){
            this.$router.push({ path: '/referral/index'});
        }
        this.name = this.userInfo.receive_account_real_name;
        this.account = this.userInfo.receive_account;
    },
    methods: {
        catConfirm({ selectedValues, selectedOptions }){
            this.catShow = false;
            this.catValue = selectedValues;
            this.catText = selectedOptions[0].text;
            this.cat = selectedOptions[0].value;
        },
        setAccount(){
            let fromData = {};
            fromData.receive_account = this.account;
            fromData.real_name = this.name;

            try {
                ayzAjax.post('/referral/receive_account',fromData,{
                    headers: {
                        'Authorization': 'Bearer ' + this.jwtInfo.access_token,
                    }
                }).then((response) => {
                    if (response.data.code === 4){
                        return this.$router.push({ path: '/referral/login'});
                    }
                    if(response.data.code !== 200){
                        return showFailToast(response.data.msg)
                    }
                    return showSuccessToast('操作成功')
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试');
            }
            // this.$router.push({ path: '/referral/index'});
        },
    }
}
</script>

<style lang="scss" scoped>

.reload-view{
    background-color: #F6F6F6;
    text-align: left;
    .main{
        height: 600px;
        margin: 12px;
        //background: #42b983;
        background: #FFFFFF;
        border-radius: 17px 17px 17px 17px;
        text-align: center;
        .main-cat{
            width: 200px;
            padding-top: 25px;
            padding-left: 25px;
            padding-right: 25px;
            font-weight: 500;
            font-size: 15px;
            color: #161616;
            text-align: left;
        }
        .main-cat-option{
            margin-top: 25px;
            height: 50px;
            border-radius: 10px 10px 10px 10px;
        }
        .main-icon-tips{
            margin-top: 130px;
            margin-left: 25px;
            text-align: left;
            font-size: 15px;
            color: #222222;
        }
        .btn-container{
            margin: 20px auto;
            width: 300px;
            text-align: center;
            line-height: 50px;
            height: 50px;
            background: #FE405F;
            border-radius: 10px 10px 10px 10px;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
        }
    }
}
.main-input{
    background: #F9F9F9;
}

</style>
